import { createContext } from "react";

interface TimeZoneContextProps {
  timeZone?: string | null;
}

export const TimeZoneContext = createContext<TimeZoneContextProps>({
  timeZone: null,
});

export const TimeZoneContextProvider = ({
  timeZone,
  children,
}: {
  timeZone?: string | null;
  children: React.ReactNode;
}) => (
  <TimeZoneContext.Provider
    value={{
      timeZone,
    }}
  >
    {children}
  </TimeZoneContext.Provider>
);
